import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LRDirectHomePage from './LRDirectHomePage';
import { postLoginRoute } from '@/lib/postLoginRoute';

const Index = () => {
  const { user, loading, profile, hasActiveSubscription } = useAuth();

  // While auth (incl. Remember Me restore) is hydrating, show marketing.
  // AuthProvider awaits getSession + persisted-token restore before flipping
  // loading to false, so by the time we redirect, the session is settled.
  if (loading) return <LRDirectHomePage />;

  // Logged out → marketing homepage (current behavior).
  if (!user) return <LRDirectHomePage />;

  // Logged in but profile still loading → keep showing landing for a beat
  // rather than redirect to "/" and loop.
  if (!profile) return <LRDirectHomePage />;

  // Inactive subscription → existing AppRoutes gate will catch protected
  // routes; send them to /reactivate directly to avoid an extra hop.
  if (!hasActiveSubscription) return <Navigate to="/reactivate" replace />;

  return <Navigate to={postLoginRoute(profile.user_type)} replace />;
};

export default Index;
